var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { dumpGroupEntry } from "@hyper-hyper-space/hhs3_rdb_lang";
import { createDumpRenderOptions } from "./alias_context.js";
export function runDumpOpCommand(session, args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { groupName, hashRef } = parseArgs(args);
        const resolved = groupName === undefined
            ? yield findEntry(session, hashRef.slice(1))
            : yield resolveEntry(session, groupName, hashRef);
        const rendered = yield dumpGroupEntry(resolved.group, resolved.entryHash, {
            render: createDumpRenderOptions(session),
        });
        if (rendered === undefined)
            throw new Error(`Op '${hashRef}' is not in group`);
        return rendered;
    });
}
function parseArgs(args) {
    if (args.length === 1 && args[0].startsWith('#'))
        return { hashRef: args[0] };
    if (args.length >= 2 && args[1].startsWith('#'))
        return { groupName: args[0], hashRef: args[1] };
    throw new Error('Usage: \\dump op [group] #hash');
}
function findEntry(session, prefix) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, e_1, _b, _c;
        var _d, _e;
        const ordered = [
            ...(session.currentGroup === undefined ? [] : [session.currentGroup]),
            ...session.workspace.roots.list('group').map((root) => { var _a; return (_a = root.name) !== null && _a !== void 0 ? _a : root.id; }),
        ];
        const matches = [];
        const seen = new Set();
        for (const name of ordered) {
            const resolved = yield session.workspace.roots.resolveGroup(ref(name), { aliases: session.aliases });
            if (resolved.group === undefined || seen.has(resolved.id))
                continue;
            const group = resolved.group;
            const entries = [];
            try {
                for (var _f = true, _g = (e_1 = void 0, __asyncValues((yield group.getScopedDag()).loadAllEntries())), _h; _h = yield _g.next(), _a = _h.done, !_a; _f = true) {
                    _c = _h.value;
                    _f = false;
                    const entry = _c;
                    if (entry.hash.startsWith(prefix))
                        entries.push(entry.hash);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_f && !_a && (_b = _g.return)) yield _b.call(_g);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (entries.length > 1)
                throw new Error(`Ambiguous hash prefix '#${prefix}' in group '${name}'`);
            if (entries.length === 1) {
                seen.add(resolved.id);
                matches.push({ group, groupName: (_e = (_d = session.workspace.roots.get(resolved.id)) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : name, entryHash: entries[0] });
            }
        }
        if (matches.length === 0)
            throw new Error(`Unknown hash prefix '#${prefix}'`);
        if (matches.length > 1)
            throw new Error(`Ambiguous hash prefix '#${prefix}' (matches in: ${matches.map((m) => m.groupName).join(', ')})`);
        return matches[0];
    });
}
function resolveEntry(session, groupName, hashRef) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const resolved = yield session.workspace.roots.resolveGroup(ref(groupName), { aliases: session.aliases });
        if (resolved.group === undefined)
            throw new Error('Group is not loaded');
        return {
            group: resolved.group,
            groupName: (_b = (_a = session.workspace.roots.get(resolved.id)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : groupName,
            entryHash: yield session.workspace.roots.resolveHash(hashRefObj(hashRef), { kind: 'object', objectId: resolved.id }),
        };
    });
}
function ref(text) {
    const span = { start: 0, end: text.length, line: 1, column: 1 };
    return text.startsWith('#')
        ? { kind: 'hash', prefix: text.slice(1), span }
        : { kind: 'name', text, parts: text.split('.'), span };
}
function hashRefObj(text) {
    return { kind: 'hash', prefix: text.slice(1), span: { start: 0, end: text.length, line: 1, column: 1 } };
}
